import IMG_LOGO from "../../assets/images/tuhogar-logo.webp";

export interface ILogoProps {
  theme?: "colorful" | "white";
}

export function Logo({ theme = "colorful" }: ILogoProps) {
  return (
    <div className="flex items-center">
      <figure className="px-4">
        <img
          src={IMG_LOGO}
          alt=""
          height={40}
          className={`max-h-8 md:max-h-10 ${theme === "white" ? "brightness-0 invert" : ""}`}
        />
      </figure>
    </div>
  );
}
